import { Grid, makeStyles, Theme, Typography } from "@material-ui/core";
import { CourseDetail } from "../../../../types/course";
import { buildCourseDetailItems } from "../../../../helperfunctions/courseDetailItems";
import "../../../Courses/Course.css"

const useStyles = makeStyles((theme: Theme) => ({
    data: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        paddingRight: theme.spacing(4),
        paddingLeft: theme.spacing(4),
        backgroundColor: "#f0f0f0"
    },
    dataText: {
        display: "flex",
        alignItems: "center"
    },
    row: {
        marginTop: theme.spacing(0.5),
        marginBottom: theme.spacing(0.5),
    },
}));

interface CourseProps {
    courseDetail: CourseDetail,
}

const Course = ({ courseDetail }: CourseProps) => {
    const classes = useStyles();
    const items = buildCourseDetailItems(courseDetail, {
        typeLabel: "Type",
        datesLabel: "Cursusplanning",
        includeCategory: true,
        includeResults: false,
        includePrice: false,
        examDateAsArray: false,
    });

    return (
        <Grid container className={classes.data}>
            <Grid item xs={12}>
                <Typography variant="h6">Cursusgegevens</Typography>
            </Grid>
            {items.map(({ name, variable }) => (
                <Grid item xs={12} className={classes.row} key={name}>
                    <Grid container direction="row">
                        <Grid item xs={12} md={3} className={classes.row}>
                            <Typography className={classes.row} style={{ fontWeight: "bold" }} variant="body2">{name}</Typography>
                        </Grid>
                        <Grid item xs={12} md={9} className={classes.dataText}>
                            {Array.isArray(variable) ? (
                                <Grid container>
                                    {variable.map((v) => (
                                        <Grid item xs={12} md={6} key={v}>
                                            <Typography variant="body2">Datum: {v}</Typography>
                                        </Grid>
                                    ))}
                                </Grid>
                            ) : (
                                <Typography variant="body2">{variable}</Typography>
                            )}
                        </Grid>
                    </Grid>
                </Grid>
            ))}
        </Grid>
    );
};

export default Course;
